import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { find } from 'rxjs';
import { calendar } from 'ngx-bootstrap/chronos/moment/calendar';
import { sign } from 'crypto';
import { request } from 'http';

@Injectable({
  providedIn: 'root',
})
export class AppConfig {
  constructor() { }

  schoolAdUser = environment.apiUrl + 'api/v1/school-user/';
  // schoolChoices = environment.apiUrl +'v1/school-choices/?source=';
  meCall = environment.apiUrl + 'api/v1/mixpanel-intercom/user-data/';
  createToken = environment.apiUrl + 'oauth/v2/token/';
  getUserCredentail = environment.apiUrl + 'api/v3/school/redirect/';

  //School Api's
  schoolApiUrl = {
    getBookingList: this.schoolAdUser + 'booking-request-list/',
    bookingRequest: environment.apiUrl + 'api/v1/bookings/',
    preConfirmed: this.schoolAdUser + 'booking-preconfirmed-list/',
    findNewTeacher: this.schoolAdUser + 'find-new-teachers/',
    myTeachers: this.schoolAdUser + 'my-list/',
    myChoices: environment.apiUrl + 'api/v1/school-choices/?source=',
    groupSchoolChoices: environment.apiUrl + 'api/v1/group-school-choices/?source=',
    registerChoices: environment.apiUrl + 'api/v1/register-choices/?source=',
    preConfirmedReviewOccurence:
      environment.apiUrl + 'api/v1/bookings/get-recurring-dates/',
    cancelBookingRequest:
      environment.apiUrl + 'api/v1/bookings/cancel-booking-line-item/',
    editBookingRequest: environment.apiUrl + 'api/v1/bookings/edit-booking/',
    editBookingRequestQLD: environment.apiUrl + 'api/v1/bookings/qld-edit-booking/',
    calendar: environment.apiUrl + 'api/v1/school-user/school-calander/',
    getRequestHistory: this.schoolAdUser + 'request-history/',
    getInFlightData: this.schoolAdUser + 'booking-inflight/',
    stopBookingRequest: environment.apiUrl + 'api/v1/bookings/cancel-booking/',
    getPendingInviteList:
      environment.apiUrl + 'api/v1/invite-teacher/pending-invite/',
    getInvitePendingList: environment.apiUrl + 'api/v1/invite-teacher/pending/',
    getInviteHistoryList: environment.apiUrl + 'api/v1/invite-teacher/history/',
    updateBookingRequest:
      environment.apiUrl + 'api/v1/bookings/update-booking/',
    reSendInvite: environment.apiUrl + 'api/v1/invite-teacher/resend-invite/',
    cancelInvite: environment.apiUrl + 'api/v1/invite-teacher/cancel-invite/',
    profileSaveChanges:
      environment.apiUrl + 'api/v1/school-user/school-settings/',
    // sendMailInvite: environment.apiUrl +'api/v1/invite-teacher/send-mail/',
    sendMailInvite: environment.apiUrl + 'api/v1/school-user/send-message/',
    listHealth: environment.apiUrl + 'api/v1/school-user/teacher-health/',
    pendingRequestList:
      environment.apiUrl + 'api/v1/invite-school/pending-request/',
    pendingRequestPendingList:
      environment.apiUrl + 'api/v1/invite-school/pending/',
    pendingRequestHistoryList:
      environment.apiUrl + 'api/v1/invite-school/history/',
    pendingRequestBlockedList:
      environment.apiUrl + 'api/v1/invite-school/blocked/',
    getMyList: environment.apiUrl + 'api/v1/school-user/my-list/',
    requestAction: environment.apiUrl + 'api/v1/invite-school/request-action/',
    myListAction: environment.apiUrl + 'api/v1/school-user/mylist-actions/',
    getJobs: environment.apiUrl + 'api/v1/jobs/school-jobs/',
    getJobsListingSideCom: environment.apiUrl + 'api/v1/jobs/school-stats/',
    callBackPaymentFunctionAPI:
      environment.apiUrl + 'api/v1/school-user/check_payment/',
    boostJob: environment.apiUrl + 'api/v1/jobs/boost-job/',
    getJobDetails: environment.apiUrl + 'api/v1/jobs/job-applicants/',
    jobDetailsAction:
      environment.apiUrl + 'api/v1/jobs/update-application-status/',
    addExternalEvent: environment.apiUrl + 'api/v1/school-event/',
    postJobsApi: environment.apiUrl + 'api/v1/jobs/',
    updateJobsAPi: environment.apiUrl + 'api/v1/jobs/',
    jobMakeLive: environment.apiUrl + 'api/v1/jobs/activate-job/',
    jobSubsUpdate:
      environment.apiUrl + 'api/v1/school-user/update-job-subscription/',
    jobPaymentHistory:
      environment.apiUrl + 'api/v1/school-user/payment-history/',
    editJobsApi: environment.apiUrl + 'api/v1/jobs/job-details/',
    addNotesApi: environment.apiUrl + 'api/v1/school-user/notes-update/',
    createSmart: environment.apiUrl + 'api/v1/smart-groups/',
    ProviderRatings: environment.apiUrl + 'api/v1/update-rating/',
    calendarbookings: environment.apiUrl + 'api/v1/school-user/school-booking/',
    bulkEditData: environment.apiUrl + 'api/v1/bookings/bulk-edit-booking/',
    updateBulkDataApi:
      environment.apiUrl + 'api/v1/bookings/bulk-edit-booking/',
    // addNotesApi: environment.apiUrl +'en/school/xhr/provider/notes/update/'
    profilePageDetails:
      environment.apiUrl + 'api/v1/school-user/school-profile/',
    // editProfileData: environment.apiUrl +'api/v1/save_schoolprofile/',
    editProfileData:
      environment.apiUrl + 'api/v1/school-user/school-profile-update/',
    sendReceiveRequestAPI: environment.apiUrl + 'api/v1/show_school/',
    profilePageChanges: environment.apiUrl + 'api/v3/get_states/',
    // profilePageTimeZoneChanges: environment.apiUrl +'api/v3/time_zone/',
    sendInvite: environment.apiUrl + 'api/v1/invite-teacher/',
    getSmartGroups: environment.apiUrl + 'api/v1/smart-groups/smartgroup-list/',
    getSmartGroupsList: environment.apiUrl + 'api/v1/smart-groups/',
    smartGroupsActions: environment.apiUrl + 'api/v1/smart-groups/actions/',
    sendNudgeApi: environment.apiUrl + 'api/v1/school-user/nudge-action/',
    addToSmartGroup: environment.apiUrl + 'api/v1/smart-groups/add-list/',
    exportTeachers: environment.apiUrl + 'api/v1/school-user/export/',
    getAvailability: environment.apiUrl + 'api/v1/school-user/teacher-details/',
    saveChangesAdminSettings:
      environment.apiUrl + 'api/v1/school-user/admin-settings/',
    addAdditionalUserApi: environment.apiUrl + 'api/v1/school-user/',
    saveChangesSchoolSettings:
      environment.apiUrl + 'api/v1/school-user/school-settings/',
    manageTeamSettings: environment.apiUrl + 'api/v1/school-user/manage-team/',
    checkAvalability:
      environment.apiUrl + 'api/v1/school-user/available-check/',
    getInviteRequest: environment.apiUrl + 'api/v1/school-user/invite-request/',
    editSmartGroup: environment.apiUrl + 'api/v1/smart-groups/',
    register: environment.apiUrl + 'api/v1/school/',
    getSchoolAccessApi: environment.apiUrl + 'api/v1/request-access/school/',
    chargebee: environment.apiUrl + 'api/v1/school-user/chargebee/',
    headHunter: environment.apiUrl + 'api/v1/jobs/headhunter/',
    inviteJobApi: environment.apiUrl + 'api/v1/jobs/invite-job/',
    recentJobs: environment.apiUrl + 'api/v1/jobs/recent-job/',
    addNewList: environment.apiUrl + 'api/v1/invite-teacher/add-new/',
    schoolStaff: environment.apiUrl + 'api/v1/school-staff/school-staff/',
    updateSchoolStaff: environment.apiUrl + 'api/v1/school-staff/',
    deleteSchoolStaff: environment.apiUrl + 'api/v1/school-staff/staff-remove/',
    exportBookingsAPI:
      environment.apiUrl + 'api/v1/school-user/export-booking/',
    getHubSpokeDataAPI:
      environment.apiUrl + 'api/v1/school-user/hub-spoke-request/',
    insightReportPageAPI: environment.apiUrl + 'api/v1/dashboard-booking/',
    teachersListReportPageAPI: environment.apiUrl + 'api/v1/teachers_list/',
    absenceListGraphReportPageAPI:
      environment.apiUrl + 'api/v1/absence_list_graph/',
    absenceGraphReportPageAPI: environment.apiUrl + 'api/v1/absence_graph/',
    teachersGraphReportPageAPI: environment.apiUrl + 'api/v1/teachers_graph/',
    exportPayrollAPI: environment.apiUrl + 'api/v1/school-user/export-payroll/',
    closeSubsAPI:
      environment.apiUrl + 'api/v1/school-user/subscription-action/',
    addTeacherToList: environment.apiUrl + 'api/v1/jobs/add-teacher-list/',
    publicProfile: environment.apiUrl + 'api/v1/school/',
    jobTermsConditionAPI: environment.apiUrl + 'api/v1/accept/term_condition/',
    // api/v1/?teacher_id=3
    nextPrevFortAPI:
      environment.apiUrl + 'api/v1/school-user/teacher-fortnight/',
    checkBookingStatus:
      environment.apiUrl + 'api/v1/school-user/booking-status-check/',
    onboardingProcess:
      environment.apiUrl + 'api/v1/school-user/onboarding-verify/',
    onboardingProcessCheck:
      environment.apiUrl + 'api/v1/school-user/onboarding-complete/',
    // Nudge Inactive All Teachers List
    nudgeInactiveTeachersAPI:
      environment.apiUrl + 'api/v1/school-user/nudge-inactive/',
    getCannyIntegration: environment.apiUrl + 'api/v1/canny/sso-token/',
    jobMulilocationAPI: environment.apiUrl + 'api/v1/jobs/add-custom-location/',
    getJobMulilocationAPI: environment.apiUrl + 'api/v1/jobs/custom-location/',
    removeJobMulilocationAPI: environment.apiUrl + 'api/v1/jobs/delete-custom-location/',
    setCompatibleTeachers: environment.apiUrl + 'api/v1/school-user/set-compatible/',
    inviteByEmail: environment.apiUrl + 'api/v1/school-staff/search/',
    addQLDRolesAndPermissions: environment.apiUrl + 'api/v1/school-user/qld-school-user/',
  };

  //Group Api's
  groupApiUrl = {
    getSchoolAPI: environment.apiUrl + 'api/v1/group-user/school-list/',
    getTeacherAPI: environment.apiUrl + 'api/v1/group-user/all-teacher/',
    getLappsedAPI: environment.apiUrl + 'api/v1/group-user/lapsed-teacher/',

    getBookingsReportAPI:
      environment.apiUrl + 'api/v1/group-user/group-booking-report/',
    getBookingsDownloadReportAPI:
      environment.apiUrl + 'api/v1/group-booking-report/',
    getCustomFieldAPI:
      environment.apiUrl + 'api/v1/group-user/group-custom-field/',
    bookingsReportPageAPI: environment.apiUrl + 'api/v1/group-bookings/',
    bookingsPreConfirmReportPageAPI:
      environment.apiUrl + 'api/v1/group-booking-types/',
    removeSchoolAPI: environment.apiUrl + 'api/v1/group-user/remove-school/',
    removeTeacherAPI: environment.apiUrl + 'api/v1/group-user/teacher-remove/',
    WaggaupdateValidationAPI: environment.apiUrl + 'api/v1/wagga-validation/',
    BceupdateValidationAPI: environment.apiUrl + 'api/v1/bce-validation/',
    getLappsedApprovedAPI:
      environment.apiUrl + 'api/v1/group-user/group-invite-action/',
    pendingInviteAPI: environment.apiUrl + 'api/v1/group-user/pending-invite/',
    personalInfoAPI: environment.apiUrl + 'api/v1/group-user/setting/',
    pendingRequestAPI:
      environment.apiUrl + 'api/v1/group-user/pending-request/',
    getRequestApprovedAPI:
      environment.apiUrl + 'api/v1/group-user/group-request-action/',
    validatedTeachersGraphAPI:
      environment.apiUrl + 'api/v1/group-validated-teachers/',
    schoolEducatorsGraphAPI:
      environment.apiUrl + 'api/v1/group-school-educators/',
    schoolListGraphAPI: environment.apiUrl + 'api/v1/group-school-list/',
    CDMNupdateValidationAPI:
      environment.apiUrl + 'api/v1/group-user/cdmn-validation-update/',
    suspendTeacherAPI:
      environment.apiUrl + 'api/v1/group-user/teacher-suspend/',
    CairnsupdateValidationAPI: environment.apiUrl + 'api/v1/group-user/cairns-validation-update/',
  };


  //Group Api's
  coOrdinatorApiUrl = {
    getSchoolAPI: environment.apiUrl + 'api/v1/co-ordinator/school/',
    calendar: environment.apiUrl + 'api/v1/co-ordinator/calendar/',
    dashboardBookingRequest:
      environment.apiUrl + 'api/v1/co-ordinator/dashboard/',
    dashboardTopSchool:
      environment.apiUrl + 'api/v1/co-ordinator/topschool-booking/',
    bookingsList: environment.apiUrl + 'api/v1/co-ordinator/',
    myChoices: environment.apiUrl + 'api/v1/group-choices/',
    bookingsEdit:
      environment.apiUrl + 'api/v1/co-ordinator/booking-line-item-edit/',
    bookingsCancel:
      environment.apiUrl + 'api/v1/co-ordinator/booking-line-item-cancel/',
    getTeacherAPI: environment.apiUrl + 'api/v1/co-ordinator/teachers/',
    getRequestAPI: environment.apiUrl + 'api/v1/co-ordinator/request/',
    calendarbookingDetails:
      environment.apiUrl + 'api/v1/co-ordinator/calendar-booking/',
    disableSchoolAPI: environment.apiUrl + 'api/v1/co-ordinator/actions/',
    removeTeacherAPI:
      environment.apiUrl + 'api/v1/co-ordinator/remove-teacher/',
    declineApproveAPI:
      environment.apiUrl + 'api/v1/co-ordinator/invite-action/',
    sendMailInvite: environment.apiUrl + 'api/v1/co-ordinator/send-message/',
  };

  teacherApiURL = {
    teachersDashboardAPI: environment.apiUrl + 'api/v1/teacher/dashboard/',
    teachersDashboardBookingsAPI:
      environment.apiUrl + 'api/v1/teacher/dashboard-bookings/',
    nextPrevAPI: environment.apiUrl + 'api/v1/teacher/next-fortnight/',
    jobSaveUnsaveAPI: environment.apiUrl + 'api/v1/save-unsave-job/',
    getJobAlertAPI: environment.apiUrl + 'api/v1/teacher/my-settings/',
    teacherBookingsAPI: environment.apiUrl + 'api/v1/teacher/booking/',
    bookingAcceptDeclineAPI: environment.apiUrl + 'api/v1/booking/response/',
    teacherSideComponentAPI:
      environment.apiUrl + 'api/v1/teacher/side-component/',
    schoolInvitesAPI: environment.apiUrl + 'api/v1/teacher/school-all-invite/',
    schoolInvitesHistoryAPI:
      environment.apiUrl + 'api/v1/teacher/school-history-invite/',
    inviteActionAPI: environment.apiUrl + 'api/v1/teacher/invite',
    requestActionAPI: environment.apiUrl + 'api/v1/teacher/request-action/',
    findnewSchoolsAPI: environment.apiUrl + 'api/v1/teacher/find-new-school/',
    pendingInvitesAPI: environment.apiUrl + 'api/v1/teacher/request-pending/',
    pendingHistoryAPI: environment.apiUrl + 'api/v1/teacher/request-history/',
    teacherChoicesAPI: environment.apiUrl + 'api/v1/teacher-choices/',
    sendInviteAPI: environment.apiUrl + 'api/v1/invite-school/',
    cancelInviteAPI:
      environment.apiUrl + 'api/v1/invite-school/teacher-cancel-invite/',
    calendarAPI: environment.apiUrl + 'api/v1/teacher/calendar/',
    updateAvailabilityAPI:
      environment.apiUrl + 'api/v1/teacher/update-availability/',
    recurringDatesMatchAPI:
      environment.apiUrl + 'api/v1/teacher/recurring-date/',
    calendarStatsAPI: environment.apiUrl + 'api/v1/teacher/calendar-stats/',
    calendarbookingDetailsAPI:
      environment.apiUrl + 'api/v1/teacher/calendar-bookings/',
    cancelBookingsAPI: environment.apiUrl + 'api/v1/teacher/cancel-booking/',
    updateExternalBookingsAPI:
      environment.apiUrl + 'api/v1/teacher/external-booking-update/',
    updateQuickAvailabilityAPI:
      environment.apiUrl + 'api/v1/teacher/quick-availability-update/',
    deleteUpdateBookingAPI:
      environment.apiUrl + 'api/v1/teacher/external-booking-delete/',
    settingsPageAPI: environment.apiUrl + 'api/v1/teacher/settings/',
    sendSettingsPageAPI: environment.apiUrl + 'api/v1/teacher/my-settings/',
    passwordValidationAPI: environment.apiUrl + 'api/v3/validate_password',
    updateEmailAPI: environment.apiUrl + 'api/v3/update-email',
    activateAccountAPI: environment.apiUrl + 'api/v1/teacher/account-setting/',
    deleteAccountAPI: environment.apiUrl + 'api/v1/teacher/delete-account/',
    profileUpdateAPI: environment.apiUrl + 'api/v1/teacher/profile-update/',
    teacherJobsAPI: environment.apiUrl + 'api/v1/jobs/teacher-jobs/',
    publicJobAPI: environment.apiUrl + 'api/v1/jobs/teacher-jobs/',
    teacherJobDetailsAPI: environment.apiUrl + 'api/v1/jobs/view-job/',
    publicJobDetailsAPI: environment.apiUrl + 'api/v1/jobs/view-job/',
    savedJobs: environment.apiUrl + 'api/v1/jobs/saved-jobs/',
    appliedJobs: environment.apiUrl + 'api/v1/jobs/applied-jobs/',
    sideComponentAPI: environment.apiUrl + 'api/v1/jobs/teacher-feed/',
    applyJobAPI: environment.apiUrl + 'api/v1/jobs/click-external-job/',
    quickApplyJobAPI: environment.apiUrl + 'api/v1/jobs/apply-job/',
    updateApplicantDocumentAPI: environment.apiUrl + 'api/v1/jobs/upload-documents/',
  };

  teacherMySchoolsApiURL = {
    mySchoolsAPI: environment.apiUrl + 'api/v1/teacher/my-school-list/',
    appearAvailableAPI: environment.apiUrl + 'api/v1/teacher/actions/',
    setPreferencesAPI: environment.apiUrl + 'api/v1/teacher/set-preferrence/',
  };
  teacherProfileApiURL = {
    profilePageAPI: environment.apiUrl + 'api/v1/teacher/profile/',
    saveProfileAPI: environment.apiUrl + 'api/v1/teacher/profile-update/',
    profileAvailabilityAPI: environment.apiUrl + 'api/v1/teacher/availability/',
    saveBCEProfileAPI:
      environment.apiUrl + 'api/v1/teacher/bce-teacher-update/',
    profileDeleteAPI: environment.apiUrl + 'api/v1/teacher/remove-profile-details/',
    profilePortfolioAPI: environment.apiUrl + 'api/v1/teacher/',
    nswVerificationAPI: environment.apiUrl + 'api/v3/nsw_doe/data',
    nswVerificationConfirmAPI: environment.apiUrl + 'api/v3/nsw_doe/work',

  };

  commonApi = {
    switchBackToPython: environment.apiUrl + 'api/v1/school-user/back-to-cc/',
    loginToAngular: environment.apiUrl + 'oauth/v2/token/group',
    resetLinkAuth: environment.apiUrl + 'api/v1/reset_password/',
    resetPassword: environment.apiUrl + 'api/v1/create_new_password/',
    checkEmailExists: environment.apiUrl + 'api/v1/check_email_exists/',
    signUp: environment.apiUrl + 'api/v1/teacher/',
    logout: environment.apiUrl + 'oauth/v2/logout/',
    switchBackToPythonTeacher: environment.apiUrl + 'api/v1/teacher/back-to-cc/',
    mfaVerifyAPI: environment.apiUrl + 'api/v1/send-mfa/',
    mfaOTPVerifyAPI: environment.apiUrl + 'api/v1/mfa/login/verify/',
    emailVerifyAPI: environment.apiUrl + 'api/v1/email/verify/',
    enableMfaOtpVerifyAPI: environment.apiUrl + 'api/v1/mfa/enable/verify/',
    enableMFA: environment.apiUrl + 'api/v1/mfa/enable/',
    disableMFA: environment.apiUrl + 'api/v1/mfa/disable/',
    resendMFAOtp: environment.apiUrl + 'api/v1/resend-mfa-otp/',
    resendVerifyOtp: environment.apiUrl + 'api/v1/email/verify/resend/',
    sendSmsMFAOtp: environment.apiUrl + 'api/v1/send-sms-mfa-otp/',
    mySchoolApi: environment.apiUrl + 'api/v1/school-user/my-schools/',
    isLongDayBookingEnabled: environment.apiUrl + 'api/v1/school-user/is_long_day_booking_enabled/',
    learnworldLogin: environment.apiUrl + 'api/v3/learnworld-login/mob',
    addToSchoolList: environment.apiUrl + 'api/v1/invite-teacher/inflight/',
    enableExpandList: environment.apiUrl + 'api/v1/bookings/expand/',
    setDefaultSchool: environment.apiUrl + 'api/v1/school-user/make-default/',
  };

  tracerApi = {
    getReliefTeacherAPI: environment.apiUrl + 'api/v1/tracer/pending-profile/',
    approveReliefTeacherAPI: environment.apiUrl + 'api/v1/tracer/approve-profile/',
    updateReliefTeacherRoleAPI: environment.apiUrl + 'api/v1/tracer/active-profile-action/',
    getCurrentBookingsAPI: environment.apiUrl + 'api/v1/tracer/booking/',
    assignBookingAPI: environment.apiUrl + 'api/v1/tracer/assign-booking/',
    getTeamMembersAPI: environment.apiUrl + 'api/v1/tracer/team-members/',
    cancelBookingAPI: environment.apiUrl + 'api/v1/tracer/cancel-booking/',
    tracerChoicesAPI: environment.apiUrl + 'api/v1/tracer-choices/',
    addNotesAPI: environment.apiUrl + 'api/v1/tracer/teacher-note/',
    flaggedBookingsAPI: environment.apiUrl + 'api/v1/tracer/flagged-booking/',
    flaggedApprovalAPI: environment.apiUrl + 'api/v1/tracer/approve-booking/',
    unlockReliefTeacherProfileAPI: environment.apiUrl + 'api/v1/tracer/unlock_profile/',
    tracerManageTeamSettings: environment.apiUrl + 'api/v1/tracer/manage-team/',
    tracerAddAdditionalUserApi: environment.apiUrl + 'api/v1/tracer/',
    getSchoolAPI: environment.apiUrl + 'api/v1/tracer/school-list/',
    removeSchoolAPI: environment.apiUrl + 'api/v1/group-user/remove-school/',
    getCancelledBookingsAPI: environment.apiUrl + 'api/v1/tracer/cancel-bookings/',
    getInFlightData: environment.apiUrl + 'api/v1/tracer/booking-inflight/',
    getPayrollReport: environment.apiUrl + 'api/v1/tracer/booking-report/',
    downloadReport: environment.apiUrl + 'api/v1/tracer/download-report/',
    calendar: environment.apiUrl + 'api/v1/tracer/calendar/',
    bookingExportTracer: environment.apiUrl + 'api/v1/tracer/export-booking/',
    makeRolesAndPermissionsQLD: environment.apiUrl + 'api/v1/tracer/update/',
    getTracerReport: environment.apiUrl + 'api/v1/tracer/report/',
    rtTeacherBookingsReport: environment.apiUrl + 'api/v1/tracer/export-relief-booking/',
    contractTeacherBookingsReport: environment.apiUrl + 'api/v1/tracer/lrt-drt-booking/',
    cancellationReport: environment.apiUrl + 'api/v1/tracer/export-cancelled-booking/',
    schoolActivityReport: environment.apiUrl + 'api/v1/tracer/school-activity-report/',
    activatedReliefTeachersReport: environment.apiUrl + 'api/v1/tracer/export-active-teachers/',
    submitSupportNotes: environment.apiUrl + 'api/v1/tracer/support-notes/',
  };

  // QLD Api Urls
  qldApiUrl = {
    qld_verification: environment.apiUrl + 'api/v1/teacher/qld_verification/',
    employee_details: environment.apiUrl + 'api/v1/teacher/employee_details/',
    check_eq_id: environment.apiUrl + 'api/v1/teacher/qld_eq_verify/',
    get_booking_confirmation: environment.apiUrl + 'api/v1/school-user/booking-confirmation/',
    cancelBookingApi: environment.apiUrl + 'api/v1/school-user/booking-confirmation/cancel/',
    submit_booking_confirmation: environment.apiUrl + 'api/v1/school-user/confirm-attendance/',
    undo_confirm_booking: environment.apiUrl + 'api/v1/school-user/undo-confirm-booking/',
    circuit_teacher_list: environment.apiUrl + 'api/v1/school-user/circuit-teacher-list/',
    circuit_booking: environment.apiUrl + 'api/v1/bookings/circuit-booking/',
    update_circuit_booking: environment.apiUrl + 'api/v1/bookings/update-circuit-booking/',
    remove_school: environment.apiUrl + 'api/v1/bookings/remove-circuit-school/',
    request_tracer_help: environment.apiUrl + 'api/v1/teacher/request_tracer_help/',
    delete_qld_account: environment.apiUrl + 'api/v1/teacher/delete-request/',
    deactivate_qld_account: environment.apiUrl + 'api/v1/teacher/deactivation-request/',
    reactivate_qld_account: environment.apiUrl + 'api/v1/teacher/reactivation-request/',
    qld_status_update: environment.apiUrl + 'api/v1/teacher/qld_status_update/',
  };
}
